import { Component } from '@angular/core';

@Component({
  selector: 'app-create-storybooks',
  imports: [],
  templateUrl: './create-storybooks.html',
  styleUrl: './create-storybooks.scss',
})
export class CreateStorybooks {

}
